/**
 * Detekce typu media (image / video / audio) podle přípony.
 */

const IMG_EXTS   = ['jpg','jpeg','png','gif','webp','heic','heif','avif'];
const VIDEO_EXTS = ['mp4','mov','webm','m4v','avi','mkv'];
const AUDIO_EXTS = ['mp3','wav','m4a','ogg','oga','flac','aac'];

export function getMediaType(pathOrName) {
    const ext = (pathOrName?.split('.').pop() || '').toLowerCase();
    if (IMG_EXTS.includes(ext))   return 'image';
    if (VIDEO_EXTS.includes(ext)) return 'video';
    if (AUDIO_EXTS.includes(ext)) return 'audio';
    return 'unknown';
}

export const ACCEPT_ALL_MEDIA = 'image/*,video/*,audio/*';

/**
 * SVG ikony pro thumbnail overlay.
 */
export const PLAY_ICON_SVG = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>`;
export const MUSIC_ICON_SVG = `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/></svg>`;

/**
 * Vrátí HTML pro thumbnail dle typu media.
 *   - image: <img class="thumb" src="url" ...>
 *   - video/audio: <div class="thumb media-thumb video|audio"> ikona + label </div>
 */
export function mediaThumbHTML({ url, path, mediaType, dataAttrs = '' }) {
    const ext = (path?.split('.').pop() || '').toUpperCase();
    if (mediaType === 'image') {
        return `<img class="thumb" src="${url}" alt="" ${dataAttrs} title="Klikni pro zvětšení">`;
    }
    if (mediaType === 'video') {
        return `<div class="thumb media-thumb video-thumb" ${dataAttrs} title="Klikni pro přehrání videa">
            <div class="play-overlay">${PLAY_ICON_SVG}</div>
            <span class="media-ext">${ext}</span>
        </div>`;
    }
    if (mediaType === 'audio') {
        return `<div class="thumb media-thumb audio-thumb" ${dataAttrs} title="Klikni pro přehrání zvuku">
            <div class="play-overlay">${MUSIC_ICON_SVG}</div>
            <span class="media-ext">${ext}</span>
        </div>`;
    }
    return `<div class="thumb" ${dataAttrs}>${ext || '?'}</div>`;
}
